import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../../components/Auth/LoginForm";
import LoadingCircle from "../../components/Common/LoadingCircle";
import VerificationModal from "../../components/Common/VerificationModal"; 
import { loginAPI } from "../../api/authApi"; 

const LoginPage = ({ theme, toggleTheme, showBackToTop }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Konfigurasi Modal Dinamis
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: "",
    message: ""
  });

  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 0); 
    return () => clearTimeout(timer);
  }, []);

  const handleLoginProcess = async (email, password, captchaToken) => {
    // 1. VALIDASI RECAPTCHA DENGAN MODAL
    if (!captchaToken) {
      setModalConfig({
        isOpen: true,
        title: "Verifikasi Keamanan",
        message: "Maaf, Anda harus mencentang kotak 'I'm not a robot' untuk memastikan keamanan akses sistem."
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await loginAPI(email, password);
      const { role, name, token, image } = result.data;

      // 2. SIMPAN SESI KE LOCALSTORAGE
      localStorage.setItem("eventManagementAuthToken", token);
      localStorage.setItem("eventManagementUserRole", role);
      localStorage.setItem("eventManagementAUserName", name);
      localStorage.setItem("eventManagementAUserImage", image || "");

      // 3. NAVIGASI BERDASARKAN ROLE
      // Admin dan Helper diarahkan ke dashboard admin sesuai permintaan Anda
      if (role === "Admin" || role === "Helper") {
        navigate("/admin");
      } else {
        navigate("/");
      }

    } catch (error) {
      setModalConfig({
        isOpen: true,
        title: "Login Gagal",
        message: error.message || "Kombinasi email atau password Anda salah. Silakan periksa kembali."
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) return <LoadingCircle fullPage={true} size="lg" />;

  return (
    <div className="min-h-screen w-full flex flex-col  relative font-sans overflow-hidden">
      
      {/* MODAL VERIFIKASI TERPISAH */}
      <VerificationModal 
        isOpen={modalConfig.isOpen}
        onClose={() => setModalConfig({ ...modalConfig, isOpen: false })}
        title={modalConfig.title}
        message={modalConfig.message}
        buttonText="Perbaik"
      />

      <main className="relative z-10 flex-grow w-full flex flex-col items-center justify-center py-20 px-6">
        {/* Container Form dibuat lebar agar gagah */}
        <div className="w-full max-w-[1400px] flex justify-center animate-in fade-in slide-in-from-bottom-4 duration-700">
          <LoginForm 
            onLoginSubmit={handleLoginProcess} 
            isSubmitting={isSubmitting}
          />
        </div>
      </main>
    </div>
  );
};

export default LoginPage;